/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { ReactNode } from 'react'
import { ToastContainer, cssTransition } from 'react-toastify'

import { useThemeContext } from '../../contexts/ThemeContext'

const transition = cssTransition({
  enter: 'animate__animated animate__faster animate__fadeInRight',
  exit: 'animate__animated animate__fast animate__zoomOut'
})

type ToastContentProps = {
  message:
    | string
    | {
        header: string
        detail: ReactNode
        additionalContent?: ReactNode
      }
}

export const ToastContent = ({ message }: ToastContentProps) => {
  return typeof message === 'string' ? (
    <>{message}</>
  ) : (
    <>
      <div>
        <strong>{message.header}</strong>
      </div>
      <small>{message.detail}</small>
      {message.additionalContent}
    </>
  )
}

const Toast = () => {
  const { darkMode } = useThemeContext()

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={darkMode ? 'dark' : 'light'}
      transition={transition}
    />
  )
}

export default Toast
